import { createContext, useContext, useState } from "react";

export const FlagContext = createContext<Record<string, string> | null>(null);

export function useFlag() {
  return useContext(FlagContext);
}

export function FlagProvider({
  flag,
  children,
}: {
  flag: Record<string, string> | null;
  children: React.ReactNode;
}) {
  // 服务端的flag只需要读取一次
  const [flagValue] = useState(flag);

  return (
    <FlagContext.Provider value={flagValue}>{children}</FlagContext.Provider>
  );
}
